import { actionTypes } from '../actions/constants';

export default function footerReducer(state = {}, action) {
    switch (action.type) {
        case actionTypes.SET_CURRENCY:
            return {
                ...state,
                userCurrency: action.currency,
            };
        case actionTypes.SET_CURRENCY_UPDATED:
            return {
                ...state,
                currencyUpdated: action.currencyUpdated,
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/footerReducer.js